import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const APPLE_BADGE = {
  en: "/wallet/apple-en.svg",
  fr: "/wallet/apple-fr.svg",
  es: "/wallet/apple-es.svg",
  ar: "/wallet/apple-ar.svg",
};

const GOOGLE_BADGE = {
  en: "/wallet/google-en.png",
  fr: "/wallet/google-fr.png",
  es: "/wallet/google-es.png",
  ar: "/wallet/google-ar.png",
};

// Unified pill height keeps both badges visually the same size,
// regardless of their native aspect ratios.
const BADGE_HEIGHT = 44;

export const WalletBadges = ({ slug, className = "" }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0];
  const appleSrc = APPLE_BADGE[lang] || APPLE_BADGE.en;
  const googleSrc = GOOGLE_BADGE[lang] || GOOGLE_BADGE.en;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
      className={`flex flex-wrap items-center gap-3 ${className}`}
      data-testid={`wallet-badges-${slug || "default"}`}
      aria-label="Add to mobile wallet"
    >
      <img
        src={appleSrc}
        alt="Add to Apple Wallet"
        style={{ height: BADGE_HEIGHT, width: "auto" }}
        className="rounded-[10px] transition-transform duration-200 hover:scale-[1.04]"
        loading="lazy"
        data-testid={`wallet-badge-apple-${slug || "default"}`}
      />
      <img
        src={googleSrc}
        alt="Add to Google Wallet"
        style={{ height: BADGE_HEIGHT, width: "auto" }}
        className="rounded-[10px] transition-transform duration-200 hover:scale-[1.04]"
        loading="lazy"
        data-testid={`wallet-badge-google-${slug || "default"}`}
      />
    </motion.div>
  );
};

export default WalletBadges;
